import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useT } from "@/i18n";

export const CookieConsent = () => {
  const { t } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("gp_cookie_consent")) setShow(true);
  }, []);

  const decide = (val) => {
    localStorage.setItem("gp_cookie_consent", val);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-2xl rounded-2xl border border-border bg-card p-4 shadow-xl sm:flex sm:items-center sm:gap-4"
          data-testid="cookie-consent">
          <p className="text-sm text-muted-foreground">{t("legal.cookieConsent")}</p>
          <div className="mt-3 flex gap-2 sm:mt-0 sm:shrink-0">
            <Button variant="ghost" size="sm" onClick={() => decide("rejected")} data-testid="cookie-reject">{t("legal.reject")}</Button>
            <Button size="sm" onClick={() => decide("accepted")} className="bg-brand-500 hover:bg-brand-600 text-black" data-testid="cookie-accept">{t("legal.accept")}</Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
